import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedBalanceHistoryResultRequestDto } from 'src/app/models/backend';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BalanceHistoriesService {
  id: any;
  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);
  constructor(private http: HttpClient) { }

  readonly url = environment.apiUrl+'BalanceHistories/'

  createBalanceHistory(CreateProductDto) {
    return this.http.post(this.url + 'CreateBalanceHistory',
      CreateProductDto, { headers: this.headers })
  }

  getBalanceHistories(payload: IPagedBalanceHistoryResultRequestDto) {
    return this.http.post<PagedResultDto<IPagedBalanceHistoryResultRequestDto>>(this.url + 'GetBalanceHistories', payload, { headers: this.headers });
  }

  

}
